export default __webpack_public_path__ + "static/media/01 Marketing - Floor Plan by Type 12.dc240a6c.jpeg";